import { useFlutterwave } from 'flutterwave-react-v3';
import { useSelector } from 'react-redux';
import { RootState } from '../../states/reducers';

export const useFlutterwavePayment = (amount: number, title: string, description: string) => {
  const { user } = useSelector((state: RootState) => state.auth.authUser!);

  const config = {
    public_key: 'FLWPUBK_TEST-0750fd65f5e41a4fcdb38ef29120456b-X',
    tx_ref: Date.now().toString(),
    amount,
    currency: 'NGN',
    payment_options: 'card',
    customer: {
      email: user.email,
      phonenumber: '',
      name: `${user.firstname} ${user.lastname}`,
    },
    customizations: {
      title: title,
      description: description,
      logo: '',
    },
  };

  const handleFlutterPayment = useFlutterwave(config);

  return {
    handleFlutterPayment,
  };
};
